import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import "./yurtcump.css";
import { toast } from "react-toastify";
import { io } from "socket.io-client";
const statusLabel = { free: "Свободна", busy: "Занята", repair: "На ремонте" };
const payLabel = { cash: "Наличка", terminal: "Терминал", click: "Click", debt: "Долг" };

const YurtCump = ({ logout, user, API_URL }) => {
    // Редактировать может только admin или подроль "yurtcump", остальные — только просмотр
    const userRole = (user?.role || "").trim().toLowerCase();
    const userSubroles = (user?.subroles || []).map((r) => String(r).trim().toLowerCase());
    const canEdit = userRole === "admin" || userSubroles.includes("yurtcump");

    const [yurts, setYurts] = useState([]);
    const [bookings, setBookings] = useState([]);
    const [dayStatuses, setDayStatuses] = useState([]);
    const [badDays, setBadDays] = useState([]);
    const [currentDate, setCurrentDate] = useState(new Date());

    const [modal, setModal] = useState({
        open: false,
        yurtId: null,
        yurtName: "",
        day: "",
        weekday: "",
        monthName: "",
        date: "",
    });
    const [cellCurrent, setCellCurrent] = useState([]);
    const [cellPool, setCellPool] = useState([]);
    const [cellDayStatus, setCellDayStatus] = useState("free");
    const [selectedKey, setSelectedKey] = useState("");
    const [poolCount, setPoolCount] = useState(0);

    // модалка "кол-во юрт"
    const [countModal, setCountModal] = useState({ open: false, value: 0 });
    const titleClickCount = useRef(0);
    const titleClickTimer = useRef(null);

    // модалка "добавить/изменить бронь" (создаёт или обновляет элемент пула)
    const [orderModal, setOrderModal] = useState({ open: false });
    const [editingOrderId, setEditingOrderId] = useState(null);
    const [orderStart, setOrderStart] = useState("");
    const [orderEnd, setOrderEnd] = useState("");
    const [orderNote, setOrderNote] = useState("");
    const [orderPrice, setOrderPrice] = useState(0);
    const [orderMealBreakfast, setOrderMealBreakfast] = useState(false);
    const [orderMealBreakfastPrice, setOrderMealBreakfastPrice] = useState(0);
    const [orderMealDinner, setOrderMealDinner] = useState(false);
    const [orderMealDinnerPrice, setOrderMealDinnerPrice] = useState(0);
    const [orderExtraServices, setOrderExtraServices] = useState([]);
    const [orderGuests, setOrderGuests] = useState([
        { name: "", country: "", passport: "", pay: "cash" },
    ]);

    // вкладки: 'calendar' | 'list'
    const [activeTab, setActiveTab] = useState("calendar");
    const [manualOrders, setManualOrders] = useState([]);
    const [viewOrder, setViewOrder] = useState(null); // карточка деталей брони

    const months = [
        "Январь", "Февраль", "Март", "Апрель", "Май", "Июнь",
        "Июль", "Август", "Сентябрь", "Октябрь", "Ноябрь", "Декабрь",
    ];
    const weekDays = ["Вс", "Пн", "Вт", "Ср", "Чт", "Пт", "Сб"];

    const monthName = months[currentDate.getMonth()];
    const year = currentDate.getFullYear();
    const daysInMonth = new Date(currentDate.getFullYear(), currentDate.getMonth() + 1, 0).getDate();
    const days = Array.from({ length: daysInMonth }, (_, i) => i + 1);

    const prevMonth = () => {
        const date = new Date(currentDate);
        date.setMonth(date.getMonth() - 1);
        setCurrentDate(date);
    };
    const nextMonth = () => {
        const date = new Date(currentDate);
        date.setMonth(date.getMonth() + 1);
        setCurrentDate(date);
    };
    const getWeekDay = (day) =>
        weekDays[new Date(currentDate.getFullYear(), currentDate.getMonth(), day).getDay()];
    const pad2 = (n) => String(n).padStart(2, "0");
    const dateStr = (day) =>
        `${currentDate.getFullYear()}-${pad2(currentDate.getMonth() + 1)}-${pad2(day)}`;

    // ── Загрузка юрт ──
    const getYurts = async () => {
        try {
            const res = await axios.post(`${API_URL}/getYurts`);
            setYurts(res.data);
        } catch (err) {
            console.error(err);
        }
    };
    useEffect(() => {
        getYurts();
    }, []);

    // ── Загрузка занятости + статусов + red-days на месяц ──
    const refreshMonthData = async () => {
        try {
            const [assignRes, coverRes] = await Promise.all([
                axios.post(`${API_URL}/getYurtMonthAssignments`, {
                    year: currentDate.getFullYear(),
                    month: currentDate.getMonth() + 1,
                }),
                axios.post(`${API_URL}/getYurtMonthCoverage`, {
                    year: currentDate.getFullYear(),
                    month: currentDate.getMonth() + 1,
                }),
            ]);
            setBookings(assignRes.data.bookings || []);
            setDayStatuses(assignRes.data.statuses || []);
            setBadDays(coverRes.data.badDays || []);
        } catch (err) {
            console.error("Ошибка загрузки занятости юрт:", err);
        }
    };
    useEffect(() => {
        refreshMonthData();
    }, [currentDate]);

    // ─── Realtime: обновление при действиях других операторов ───
    useEffect(() => {
        const socketUrl = API_URL.replace(/\/api\/?$/, "");
        const socket = io(socketUrl);

        socket.on("calendar:update", () => {
            refreshMonthData();

            if (activeTab === "list") {
                getManualOrdersList();
            }

            if (modal.open) {
                refreshCell();
            }
        });

        return () => socket.disconnect();
    }, [API_URL, activeTab, modal.open, modal.yurtId, modal.date]);

    const getManualOrdersList = async () => {
        try {
            const res = await axios.post(`${API_URL}/getManualOrdersList`, {
                year: currentDate.getFullYear(),
                month: currentDate.getMonth() + 1,
            });
            setManualOrders(res.data.orders || []);
        } catch (err) {
            console.error("Ошибка загрузки списка броней:", err);
        }
    };
    useEffect(() => {
        if (activeTab === "list") {
            getManualOrdersList();
        }
    }, [activeTab, currentDate]);

    const deleteManualOrder = async (id, title) => {
        if (!canEdit) return;
        if (!window.confirm(`Удалить бронь "${title}"? Она будет снята со всех юрт.`)) return;
        try {
            await axios.post(`${API_URL}/deleteManualOrder`, { id });
            toast.success("Бронь удалена");
            getManualOrdersList();
            refreshMonthData();
        } catch (err) {
            console.error(err);
            toast.error("Не удалось удалить бронь");
        }
    };

    const isBadDay = (day) => badDays.includes(day);
    // День выезда не занимает юрту: 12–13 → только 12; бронь в один день (8–8) → 8
    const occupiesDay = (b, ds) =>
        b.dateStart <= ds && (b.dateEnd > ds || (b.dateStart === b.dateEnd && b.dateStart === ds));

    const getBookingsForCell = (yurtId, day) => {
        const ds = dateStr(day);
        return bookings.filter((b) => b.yurtId === yurtId && occupiesDay(b, ds));
    };
    const getDayStatus = (yurtId, day) => {
        const ds = dateStr(day);
        const found = dayStatuses.find((s) => s.yurtId === yurtId && s.date === ds);
        return found ? found.status : "free";
    };

    // ── "+ Юрты" — модалка с количеством (открывается по 5 кликам на заголовок) ──
    const handleTitleClick = () => {
        if (!canEdit) return;
        titleClickCount.current += 1;
        if (titleClickTimer.current) clearTimeout(titleClickTimer.current);

        if (titleClickCount.current >= 5) {
            titleClickCount.current = 0;
            openCountModal();
            return;
        }

        titleClickTimer.current = setTimeout(() => {
            titleClickCount.current = 0;
        }, 1500);
    };
    const openCountModal = () => {
        setCountModal({ open: true, value: yurts.length });
    };
    const saveYurtCount = async () => {
        const target = Math.max(0, Number(countModal.value) || 0);
        if (target < yurts.length) {
            const removed = yurts.length - target;
            if (!window.confirm(`Это удалит последние ${removed} юрт(ы) и все их брони. Продолжить?`)) {
                return;
            }
        }
        try {
            await axios.post(`${API_URL}/setYurtCount`, { count: target });
            toast.success("Количество юрт обновлено");
            setCountModal({ open: false, value: 0 });
            getYurts();
            refreshMonthData();
        } catch (err) {
            console.error(err);
            toast.error("Не удалось обновить количество юрт");
        }
    };

    // ── "+ Добавить бронь" / "Изменить бронь" — создаёт или обновляет элемент пула ──
    const openOrderModal = (order = null) => {
        if (order) {
            setEditingOrderId(order.id);
            setOrderStart(order.dateStart);
            setOrderEnd(order.dateEnd);
            setOrderNote(order.note || "");
            setOrderPrice(order.price || 0);
            setOrderMealBreakfast(order.mealBreakfast || false);
            setOrderMealBreakfastPrice(order.mealBreakfastPrice || 0);
            setOrderMealDinner(order.mealDinner || false);
            setOrderMealDinnerPrice(order.mealDinnerPrice || 0);
            setOrderExtraServices(order.extraServices?.length ? order.extraServices : []);
            setOrderGuests(
                order.guests?.length
                    ? order.guests.map((g) => ({ ...g }))
                    : [{ name: "", country: "", passport: "", pay: "cash" }]
            );
        } else {
            const today = dateStr(new Date().getDate());
            setEditingOrderId(null);
            setOrderStart(today);
            setOrderEnd(today);
            setOrderNote("");
            setOrderPrice(0);
            setOrderMealBreakfast(false);
            setOrderMealBreakfastPrice(0);
            setOrderMealDinner(false);
            setOrderMealDinnerPrice(0);
            setOrderExtraServices([]);
            setOrderGuests([{ name: "", country: "", passport: "", pay: "cash" }]);
        }
        setOrderModal({ open: true });
    };
    const addOrderGuestSlot = () => {
        setOrderGuests((prev) => [...prev, { name: "", country: "", passport: "", pay: "cash" }]);
    };
    const removeOrderGuestSlot = (idx) => {
        setOrderGuests((prev) => prev.filter((_, i) => i !== idx));
    };
    const updateOrderGuestField = (idx, field, value) => {
        setOrderGuests((prev) => prev.map((g, i) => (i === idx ? { ...g, [field]: value } : g)));
    };

    const addExtraService = () => {
        setOrderExtraServices((prev) => [...prev, { name: "", price: 0 }]);
    };
    const removeExtraService = (idx) => {
        setOrderExtraServices((prev) => prev.filter((_, i) => i !== idx));
    };
    const updateExtraService = (idx, field, value) => {
        setOrderExtraServices((prev) =>
            prev.map((s, i) => (i === idx ? { ...s, [field]: value } : s))
        );
    };

    const nightsBetween = (start, end) => {
        if (!start || !end) return 0;
        return Math.max(0, Math.round((new Date(end) - new Date(start)) / 86400000));
    };
    const extraServicesTotal = (list) =>
        (list || []).reduce((s, x) => s + (Number(x.price) || 0), 0);
    const orderTotal = () => {
        const meal =
            (orderMealBreakfast ? Number(orderMealBreakfastPrice) || 0 : 0) +
            (orderMealDinner ? Number(orderMealDinnerPrice) || 0 : 0);
        return (Number(orderPrice) || 0) + meal + extraServicesTotal(orderExtraServices);
    };

    const saveManualOrder = async () => {
        if (!canEdit) return;
        const guests = orderGuests.filter((g) => g.name.trim());
        if (!guests.length) {
            toast.error("Добавьте хотя бы одного гостя");
            return;
        }
        if (!orderStart || !orderEnd || orderStart > orderEnd) {
            toast.error("Проверьте даты");
            return;
        }
        const payload = {
            dateStart: orderStart,
            dateEnd: orderEnd,
            guests,
            note: orderNote,
            price: Number(orderPrice) || 0,
            mealBreakfast: orderMealBreakfast,
            mealBreakfastPrice: Number(orderMealBreakfastPrice) || 0,
            mealDinner: orderMealDinner,
            mealDinnerPrice: Number(orderMealDinnerPrice) || 0,
            extraServices: orderExtraServices.filter((s) => s.name.trim()),
        };
        try {
            const res = editingOrderId
                ? await axios.post(`${API_URL}/updateManualOrder`, { id: editingOrderId, ...payload })
                : await axios.post(`${API_URL}/addManualOrder`, payload);
            if (res.data.status === "error") {
                toast.error(res.data.message || "Не удалось сохранить бронь");
                return;
            }
            toast.success(editingOrderId ? "Бронь обновлена" : "Бронь создана — распределите по юртам в календаре");
            setOrderModal({ open: false });
            setViewOrder(null);
            refreshMonthData();
            if (activeTab === "list") getManualOrdersList();
        } catch (err) {
            console.error(err);
            toast.error("Не удалось сохранить бронь");
        }
    };

    // ── Открытие модалки ячейки ──
    const openCell = async (yurt, day) => {
        const ds = dateStr(day);
        setModal({
            open: true,
            yurtId: yurt.id,
            yurtName: yurt.name,
            day,
            weekday: getWeekDay(day),
            monthName,
            date: ds,
        });
        setSelectedKey("");
        setPoolCount(0);

        try {
            const res = await axios.post(`${API_URL}/getYurtCellInfo`, {
                yurtId: yurt.id,
                date: ds,
            });
            setCellPool(res.data.pool || []);
            setCellCurrent(res.data.current || []);
            setCellDayStatus(res.data.dayStatus || "free");
        } catch (err) {
            console.error("Ошибка загрузки данных ячейки:", err);
            setCellPool([]);
            setCellCurrent([]);
            setCellDayStatus("free");
        }
    };

    const refreshCell = async () => {
        try {
            const res = await axios.post(`${API_URL}/getYurtCellInfo`, {
                yurtId: modal.yurtId,
                date: modal.date,
            });
            setCellPool(res.data.pool || []);
            setCellCurrent(res.data.current || []);
            setCellDayStatus(res.data.dayStatus || "free");
        } catch (err) {
            console.error(err);
        }
    };

    const changeDayStatus = async (status) => {
        if (!canEdit) return;
        try {
            await axios.post(`${API_URL}/updateYurtDayStatus`, {
                yurtId: modal.yurtId,
                date: modal.date,
                status,
            });
            setCellDayStatus(status);
            if (status !== "free") {
                setSelectedKey("");
                setPoolCount(0);
            }
            refreshMonthData();
        } catch (err) {
            console.error(err);
            toast.error("Не удалось изменить статус");
        }
    };

    const removeBooking = async (bookingId) => {
        if (!canEdit) return;
        try {
            await axios.post(`${API_URL}/clearYurtBooking`, { bookingId });
            toast.success("Бронь убрана");
            refreshCell();
            refreshMonthData();
        } catch (err) {
            console.error(err);
            toast.error("Не удалось убрать бронь");
        }
    };

    const addToYurt = async () => {
        if (!canEdit || !selectedKey || poolCount <= 0) return;
        try {
            const res = await axios.post(`${API_URL}/assignYurtTour`, {
                yurtId: modal.yurtId,
                key: selectedKey,
                count: poolCount,
            });
            if (res.data.status === "error") {
                toast.error(res.data.message || "Не удалось добавить");
                return;
            }
            toast.success("Добавлено в юрту");
            setSelectedKey("");
            setPoolCount(0);
            refreshCell();
            refreshMonthData();
        } catch (err) {
            console.error(err);
            toast.error("Не удалось добавить");
        }
    };

    const selectedPoolItem = cellPool.find((t) => t.key === selectedKey);
    // В окне ячейки тоже не показываем брони, у которых этот день — день выезда
    const visibleCurrent = cellCurrent.filter((b) => occupiesDay(b, modal.date));
    return (
        <div className="yurtcump">
            <div className="yurtcump-flex">
                <div className="yurtcump-section1">
                    <div className="yurtcump-section1-text" onClick={handleTitleClick} style={{ cursor: "default", userSelect: "none" }}>
                        Юрты <br />Занятость
                    </div>
                    <div className="yurtcump-section1-dateselect">
                        <button className="yc-month-btn" onClick={prevMonth}>
                            <i className="fa-solid fa-angle-left"></i>
                        </button>
                        <span className="yc-month-title">{monthName} {year}</span>
                        <button className="yc-month-btn" onClick={nextMonth}>
                            <i className="fa-solid fa-angle-right"></i>
                        </button>
                    </div>
                    <div style={{ display: "flex", gap: 10 }}>
                        {canEdit ? (
                            <button className="yc-add-yurt-btn" onClick={() => openOrderModal()}>
                                <i className="fa-solid fa-plus"></i> Добавить бронь
                            </button>
                        ) : (
                            <span className="yc-readonly-badge"><i className="fa-solid fa-eye"></i> Только просмотр</span>
                        )}
                    </div>
                </div>

                <div className="yc-tabs-bar">
                    <button
                        className={`yc-tab-btn ${activeTab === "calendar" ? "active" : ""}`}
                        onClick={() => setActiveTab("calendar")}
                    >
                        Календарь
                    </button>
                    <button
                        className={`yc-tab-btn ${activeTab === "list" ? "active" : ""}`}
                        onClick={() => setActiveTab("list")}
                    >
                        Список броней
                    </button>
                </div>

                {activeTab === "calendar" ? (
                    <div className="yurtcump-section2">
                        <table className="yurtcump-table">
                            <thead>
                                <tr>
                                    <th className="yc-sticky-col yurt-modelname">Юрта</th>
                                    {days.map((day) => (
                                        <th key={day} className={isBadDay(day) ? "yc-bad-day" : ""}>
                                            <div className="yc-day-num">{day}</div>
                                            <div className="yc-weekday">{getWeekDay(day)}</div>
                                        </th>
                                    ))}
                                </tr>
                            </thead>
                            <tbody>
                                {yurts.map((yurt) => (
                                    <tr key={yurt.id}>
                                        <td className="yc-sticky-col yurt-name">
                                            <div className="yc-yurt-name-text">{yurt.name}</div>
                                        </td>

                                        {days.map((day) => {
                                            const dayBookings = getBookingsForCell(yurt.id, day);
                                            const hasCancelled = dayBookings.some((b) => b.isCancelled);
                                            const dStatus = getDayStatus(yurt.id, day);
                                            return (
                                                <td
                                                    key={day}
                                                    className={`yc-day-cell ${dayBookings.length ? "yc-day-cell-assigned" : ""} ${hasCancelled ? "yc-day-cell-cancelled" : ""} ${dStatus !== "free" ? `yc-cell-${dStatus}` : ""}`}
                                                    onClick={() => openCell(yurt, day)}
                                                >
                                                    {dayBookings.map((b) => {
                                                        let line = `${b.source === "tour" ? "Тур" : "Бронь"} №${b.orderNumber}${b.customer ? ` — ${b.customer}` : ""} — ${b.title} (${b.count})`;
                                                        if (b.isCancelled) line += " (отменён)";
                                                        return (
                                                            <div
                                                                key={b.bookingId}
                                                                className={`yc-cell-line ${b.source === "manual" ? "yc-cell-line-manual" : "yc-cell-line-tour"} ${b.isCancelled ? "yc-cell-line-cancelled" : ""}`}
                                                            >
                                                                {line}
                                                            </div>
                                                        );
                                                    })}
                                                    {!dayBookings.length && dStatus !== "free" && (
                                                        <div className="yc-cell-line yc-status-line">
                                                            {statusLabel[dStatus]}
                                                        </div>
                                                    )}
                                                </td>
                                            );
                                        })}
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                ) : (
                    <div className="yurtcump-section2">
                        <table className="yc-list-table">
                            <thead>
                                <tr>
                                    <th>№</th>
                                    <th>Гость(и)</th>
                                    <th>Заезд</th>
                                    <th>Выезд</th>
                                    <th>Чел.</th>
                                    <th>Распределено</th>
                                    <th>Юрты</th>
                                    <th>Заметка</th>
                                    <th></th>
                                </tr>
                            </thead>
                            <tbody>
                                {manualOrders.length === 0 && (
                                    <tr>
                                        <td colSpan={9} style={{ textAlign: "center", padding: 20, color: "#9b9b9b" }}>
                                            Пока нет ручных броней
                                        </td>
                                    </tr>
                                )}
                                {manualOrders.map((o) => {
                                    const fullyAssigned = o.assignedCount >= o.participantsCount;
                                    return (
                                        <tr
                                            key={o.id}
                                            className={o.isCancelled ? "yc-list-row-cancelled" : ""}
                                            onClick={() => setViewOrder(o)}
                                            style={{ cursor: "pointer" }}
                                        >
                                            <td>№{o.orderNumber}</td>
                                            <td>
                                                {o.title}
                                                {o.guests.length > 1 && ` +${o.guests.length - 1}`}
                                            </td>
                                            <td>{o.dateStart}</td>
                                            <td>{o.dateEnd}</td>
                                            <td>{o.participantsCount}</td>
                                            <td>
                                                <span className={fullyAssigned ? "yc-badge-ok" : "yc-badge-pending"}>
                                                    {o.assignedCount} / {o.participantsCount}
                                                </span>
                                            </td>
                                            <td>
                                                {o.yurts.length
                                                    ? o.yurts.map((y) => `${y.name} (${y.count})`).join(", ")
                                                    : "—"}
                                            </td>
                                            <td>{o.note || "—"}</td>
                                            <td>
                                                {canEdit && (
                                                    <button
                                                        className="yc-guest-remove"
                                                        onClick={(e) => {
                                                            e.stopPropagation();
                                                            deleteManualOrder(o.id, o.title);
                                                        }}
                                                    >
                                                        ✕
                                                    </button>
                                                )}
                                            </td>
                                        </tr>
                                    );
                                })}
                            </tbody>
                        </table>
                    </div>
                )}
            </div>

            {/* ── Модалка ячейки (статус дня + текущие брони + добавить из пула) ── */}
            {modal.open && (
                <div className="yc-overlay" onClick={() => setModal({ ...modal, open: false })}>
                    <div className="yc-modal" onClick={(e) => e.stopPropagation()}>
                        <div className="yc-modal-header">
                            <h2>{modal.yurtName} — {modal.day} {modal.monthName} ({modal.weekday})</h2>
                            <button className="yc-modal-close" onClick={() => setModal({ ...modal, open: false })}>✕</button>
                        </div>

                        <div className="yc-modal-section">
                            <label>СТАТУС НА ЭТОТ ДЕНЬ</label>
                            {canEdit ? (
                                <select
                                    className={`yc-status-select yc-status-${cellDayStatus}`}
                                    value={cellDayStatus}
                                    onChange={(e) => changeDayStatus(e.target.value)}
                                >
                                    <option value="free">Свободна</option>
                                    <option value="busy">Занята</option>
                                    <option value="repair">На ремонте</option>
                                </select>
                            ) : (
                                <div className={`yc-status-select yc-status-${cellDayStatus}`}>{statusLabel[cellDayStatus]}</div>
                            )}
                        </div>

                        <div className="yc-modal-section">
                            <label>ТЕКУЩИЕ БРОНИ НА ЭТОТ ДЕНЬ</label>
                            {visibleCurrent.length === 0 && (
                                <div className="yc-hint" style={{ textAlign: "center", display: "block" }}>
                                    Пока никто не заселён
                                </div>
                            )}
                            {visibleCurrent.map((b) => (
                                <div key={b.bookingId} className={`yc-order-row ${b.source === "manual" ? "yc-order-row-manual" : "yc-order-row-tour"}`}>
                                    <span>
                                        {b.source === "tour" ? "Тур" : "Бронь"} №{b.orderNumber}{b.customer ? ` — ${b.customer}` : ""} — {b.title} — {b.count} чел.
                                        {b.dateStart !== modal.date && ` (с ${b.dateStart})`}
                                    </span>
                                    {canEdit && (
                                        <button
                                            type="button"
                                            className="yc-order-remove"
                                            onClick={() => removeBooking(b.bookingId)}
                                        >
                                            ✕
                                        </button>
                                    )}
                                </div>
                            ))}
                        </div>

                        {canEdit && (
                            <div className="yc-modal-section">
                                <label>ДОБАВИТЬ (ТУР ИЛИ БРОНЬ)</label>
                                {cellDayStatus !== "free" ? (
                                    <div className="yc-hint" style={{ textAlign: "center", display: "block" }}>
                                        Юрта помечена как «{statusLabel[cellDayStatus]}» на этот день — добавление недоступно.
                                        Уже назначенные брони остаются, новые добавить нельзя, пока статус не «Свободна».
                                    </div>
                                ) : (
                                    <>
                                        <select
                                            value={selectedKey}
                                            onChange={(e) => {
                                                const val = e.target.value;
                                                setSelectedKey(val);
                                                const t = cellPool.find((x) => x.key === val);
                                                setPoolCount(t ? t.maxAvailable : 0);
                                            }}
                                        >
                                            <option value="">— Выберите —</option>
                                            {cellPool
                                                .filter((t) => t.maxAvailable > 0)
                                                .map((t) => (
                                                    <option key={t.key} value={t.key}>
                                                        {t.source === "tour" ? "Тур" : "Бронь"} №{t.orderNumber}{t.customer ? ` — ${t.customer}` : ""} — {t.title} — свободно {t.maxAvailable} из {t.total}
                                                    </option>
                                                ))}
                                        </select>

                                        {selectedPoolItem?.source === "tour" && selectedPoolItem.yurtComment && (
                                            <div className="yc-hint-comm">
                                                Размещение: {selectedPoolItem.yurtComment}
                                            </div>
                                        )}

                                        {selectedPoolItem && (
                                            <div className="yc-stepper" style={{ marginTop: 10 }}>
                                                <button
                                                    type="button"
                                                    className="yc-stepper-btn"
                                                    onClick={() => setPoolCount((c) => Math.max(0, c - 1))}
                                                >
                                                    −
                                                </button>
                                                <input
                                                    type="number"
                                                    min={0}
                                                    max={selectedPoolItem.maxAvailable}
                                                    value={poolCount}
                                                    onChange={(e) =>
                                                        setPoolCount(
                                                            Math.min(selectedPoolItem.maxAvailable, Math.max(0, Number(e.target.value) || 0))
                                                        )
                                                    }
                                                />
                                                <button
                                                    type="button"
                                                    className="yc-stepper-btn"
                                                    onClick={() =>
                                                        setPoolCount((c) => Math.min(selectedPoolItem.maxAvailable, c + 1))
                                                    }
                                                >
                                                    +
                                                </button>
                                                <button
                                                    type="button"
                                                    className="yc-add-btn"
                                                    disabled={poolCount <= 0}
                                                    onClick={addToYurt}
                                                >
                                                    +
                                                </button>
                                            </div>
                                        )}
                                    </>
                                )}
                            </div>
                        )}

                        <div className="yc-modal-actions">
                            <button className="yc-btn-cancel" onClick={() => setModal({ ...modal, open: false })}>
                                Закрыть
                            </button>
                        </div>
                    </div>
                </div>
            )}

            {/* ── Модалка "кол-во юрт" ── */}
            {canEdit && countModal.open && (
                <div className="yc-overlay" onClick={() => setCountModal({ open: false, value: 0 })}>
                    <div className="yc-modal" onClick={(e) => e.stopPropagation()}>
                        <div className="yc-modal-header">
                            <h2>Количество юрт</h2>
                            <button className="yc-modal-close" onClick={() => setCountModal({ open: false, value: 0 })}>✕</button>
                        </div>

                        <div className="yc-modal-section">
                            <label>ВСЕГО ЮРТ</label>
                            <input
                                type="number"
                                min={0}
                                className="yc-date-input"
                                value={countModal.value}
                                onChange={(e) => setCountModal({ ...countModal, value: e.target.value })}
                            />
                            <div className="yc-hint" style={{ display: "block", marginTop: 6 }}>
                                Сейчас: {yurts.length}. Если укажешь меньше — лишние юрты (с конца списка) удалятся вместе с их бронями.
                            </div>
                        </div>

                        <div className="yc-modal-actions">
                            <button className="yc-btn-cancel" onClick={() => setCountModal({ open: false, value: 0 })}>
                                Отмена
                            </button>
                            <button className="yc-btn-save" onClick={saveYurtCount}>
                                Сохранить
                            </button>
                        </div>
                    </div>
                </div>
            )}

            {/* ── Модалка "Добавить/Изменить бронь" ── */}
            {canEdit && orderModal.open && (
                <div className="yc-overlay" onClick={() => setOrderModal({ open: false })}>
                    <div className="yc-modal yc-order-modal" onClick={(e) => e.stopPropagation()}>
                        <div className="yc-modal-header">
                            <h2>{editingOrderId ? "Изменить бронь" : "Добавить бронь"}</h2>
                            <button className="yc-modal-close" onClick={() => setOrderModal({ open: false })}>✕</button>
                        </div>

                        <div className="yc-modal-section">
                            <div className="yc-form-row-2">
                                <div>
                                    <span className="yc-flabel">Заезд</span>
                                    <input
                                        type="date"
                                        className="yc-date-input"
                                        value={orderStart}
                                        onChange={(e) => setOrderStart(e.target.value)}
                                    />
                                </div>
                                <div>
                                    <span className="yc-flabel">Выезд</span>
                                    <input
                                        type="date"
                                        className="yc-date-input"
                                        value={orderEnd}
                                        onChange={(e) => setOrderEnd(e.target.value)}
                                    />
                                </div>
                            </div>
                            <div className="yc-form-row-2">
                                <div>
                                    <span className="yc-flabel">Цена проживания (общая) $</span>
                                    <input
                                        type="number"
                                        min={0}
                                        className="yc-date-input"
                                        value={orderPrice}
                                        onChange={(e) => setOrderPrice(e.target.value)}
                                    />
                                </div>
                                <div>
                                    <span className="yc-flabel">Ночей</span>
                                    <div className="yc-nights-badge">{nightsBetween(orderStart, orderEnd)}</div>
                                </div>
                            </div>

                            <div className="yc-meal-box">
                                <div className="yc-meal-box-title">Питание (за всё проживание)</div>
                                <div className="yc-meal-row">
                                    <label className="yc-meal-label-row">
                                        <input
                                            type="checkbox"
                                            checked={orderMealBreakfast}
                                            onChange={(e) => setOrderMealBreakfast(e.target.checked)}
                                        />
                                        Завтрак
                                    </label>
                                    <span>
                                        $
                                        <input
                                            type="number"
                                            min={0}
                                            className="yc-meal-price-input"
                                            value={orderMealBreakfastPrice}
                                            onChange={(e) => setOrderMealBreakfastPrice(e.target.value)}
                                        />
                                    </span>
                                </div>
                                <div className="yc-meal-row">
                                    <label className="yc-meal-label-row">
                                        <input
                                            type="checkbox"
                                            checked={orderMealDinner}
                                            onChange={(e) => setOrderMealDinner(e.target.checked)}
                                        />
                                        Ужин
                                    </label>
                                    <span>

                                        $
                                        <input
                                            type="number"
                                            min={0}
                                            className="yc-meal-price-input"
                                            value={orderMealDinnerPrice}
                                            onChange={(e) => setOrderMealDinnerPrice(e.target.value)}
                                        />
                                    </span>
                                </div>
                            </div>

                            <span className="yc-flabel">Доп. услуги (Название, Цена $)</span>
                            {orderExtraServices.map((s, idx) => (
                                <div className="yc-extra-service-row" key={idx}>
                                    <input
                                        placeholder="Название услуги"
                                        value={s.name}
                                        onChange={(e) => updateExtraService(idx, "name", e.target.value)}
                                    />
                                    <input
                                        type="number"
                                        min={0}
                                        placeholder="Цена"
                                        value={s.price}
                                        onChange={(e) => updateExtraService(idx, "price", e.target.value)}
                                    />
                                    <button
                                        type="button"
                                        className="yc-guest-remove"
                                        onClick={() => removeExtraService(idx)}
                                    >
                                        ✕
                                    </button>
                                </div>
                            ))}
                            <div className="yc-add-guest-btn" onClick={addExtraService}>+ Добавить услугу</div>

                            <div className="yc-guest-slots-title">Гости</div>
                            {orderGuests.map((g, idx) => (
                                <div className="yc-guest-slot" key={idx}>
                                    <div className="yc-guest-slot-head">
                                        <span>Гость {idx + 1}</span>
                                        {orderGuests.length > 1 && (
                                            <button
                                                type="button"
                                                className="yc-guest-remove"
                                                onClick={() => removeOrderGuestSlot(idx)}
                                            >
                                                ✕
                                            </button>
                                        )}
                                    </div>
                                    <div className="yc-guest-grid">
                                        <input
                                            placeholder="Имя Фамилия"
                                            value={g.name}
                                            onChange={(e) => updateOrderGuestField(idx, "name", e.target.value)}
                                        />
                                        <input
                                            placeholder="Страна"
                                            value={g.country}
                                            onChange={(e) => updateOrderGuestField(idx, "country", e.target.value)}
                                        />
                                        <input
                                            placeholder="Паспорт"
                                            value={g.passport}
                                            onChange={(e) => updateOrderGuestField(idx, "passport", e.target.value)}
                                        />
                                        <select
                                            value={g.pay}
                                            onChange={(e) => updateOrderGuestField(idx, "pay", e.target.value)}
                                        >
                                            <option value="cash">Наличка</option>
                                            <option value="terminal">Терминал</option>
                                            <option value="click">Click</option>
                                            <option value="debt">Долг</option>
                                        </select>
                                    </div>
                                </div>
                            ))}
                            <div className="yc-add-guest-btn" onClick={addOrderGuestSlot}>+ Добавить гостя</div>

                            <input
                                className="yc-note-input"
                                placeholder="Заметка (необязательно)"
                                value={orderNote}
                                onChange={(e) => setOrderNote(e.target.value)}
                            />

                            <div className="yc-calc-box">
                                <div className="yc-calc-row"><span>Проживание</span><span>${orderPrice || 0}</span></div>
                                {orderMealBreakfast && (
                                    <div className="yc-calc-row"><span>Завтрак</span><span>${orderMealBreakfastPrice || 0}</span></div>
                                )}
                                {orderMealDinner && (
                                    <div className="yc-calc-row"><span>Ужин</span><span>${orderMealDinnerPrice || 0}</span></div>
                                )}
                                {orderExtraServices.filter((s) => s.name.trim()).map((s, i) => (
                                    <div className="yc-calc-row" key={i}><span>{s.name}</span><span>${s.price || 0}</span></div>
                                ))}
                                <div className="yc-calc-row yc-calc-total"><span>Итого</span><span>${orderTotal()}</span></div>
                            </div>
                        </div>

                        <div className="yc-modal-actions">
                            <button className="yc-btn-cancel" onClick={() => setOrderModal({ open: false })}>
                                Отмена
                            </button>
                            <button className="yc-btn-save" onClick={saveManualOrder}>
                                {editingOrderId ? "Сохранить изменения" : "Создать бронь"}
                            </button>
                        </div>
                    </div>
                </div>
            )}

            {/* ── Карточка деталей брони (по клику на строку в списке) ── */}
            {viewOrder && (
                <div className="yc-overlay" onClick={() => setViewOrder(null)}>
                    <div className="yc-modal yc-order-modal" onClick={(e) => e.stopPropagation()}>
                        <div className="yc-modal-header">
                            <h2>№{viewOrder.orderNumber} — {viewOrder.title}</h2>
                            <button className="yc-modal-close" onClick={() => setViewOrder(null)}>✕</button>
                        </div>

                        <div className="yc-modal-info">
                            <div className="yc-info-row"><span>Заезд</span><b>{viewOrder.dateStart}</b></div>
                            <div className="yc-info-row"><span>Выезд</span><b>{viewOrder.dateEnd}</b></div>
                            <div className="yc-info-row"><span>Ночей</span><b>{nightsBetween(viewOrder.dateStart, viewOrder.dateEnd)}</b></div>
                            <div className="yc-info-row"><span>Гостей</span><b>{viewOrder.participantsCount}</b></div>
                            <div className="yc-info-row">
                                <span>Распределено</span>
                                <b className={viewOrder.assignedCount >= viewOrder.participantsCount ? "yc-text-ok" : "yc-text-pending"}>
                                    {viewOrder.assignedCount} / {viewOrder.participantsCount}
                                </b>
                            </div>
                            <div className="yc-info-row"><span>Юрты</span><b>{viewOrder.yurts.length ? viewOrder.yurts.map((y) => `${y.name} (${y.count})`).join(", ") : "—"}</b></div>
                        </div>

                        <div className="yc-guest-slots-title">Гости</div>
                        {viewOrder.guests.map((g, idx) => (
                            <div className="yc-guest-card" key={idx}>
                                <div className="yc-guest-card-name">{g.name}</div>
                                <div className="yc-guest-card-grid">
                                    <div><span className="yc-flabel">Страна</span><div>{g.country || "—"}</div></div>
                                    <div><span className="yc-flabel">Оплата</span><div>{g.pay ? (payLabel[g.pay] || g.pay) : "—"}</div></div>
                                    <div style={{ gridColumn: "1 / -1" }}><span className="yc-flabel">Паспорт</span><div>{g.passport || "—"}</div></div>
                                </div>
                            </div>
                        ))}

                        <div className="yc-calc-box">
                            <div className="yc-calc-row"><span>Проживание</span><span>${viewOrder.price}</span></div>
                            {viewOrder.mealBreakfast && (
                                <div className="yc-calc-row"><span>Завтрак</span><span>${viewOrder.mealBreakfastPrice}</span></div>
                            )}
                            {viewOrder.mealDinner && (
                                <div className="yc-calc-row"><span>Ужин</span><span>${viewOrder.mealDinnerPrice}</span></div>
                            )}
                            {viewOrder.extraServices.map((s, i) => (
                                <div className="yc-calc-row" key={i}><span>{s.name}</span><span>${s.price}</span></div>
                            ))}
                            <div className="yc-calc-row yc-calc-total">
                                <span>Итого</span>
                                <span>
                                    ${viewOrder.price +
                                        (viewOrder.mealBreakfast ? viewOrder.mealBreakfastPrice : 0) +
                                        (viewOrder.mealDinner ? viewOrder.mealDinnerPrice : 0) +
                                        viewOrder.extraServices.reduce((s, x) => s + (Number(x.price) || 0), 0)}
                                </span>
                            </div>
                        </div>

                        {viewOrder.note && (
                            <div className="yc-note-display">{viewOrder.note}</div>
                        )}

                        <div className="yc-modal-actions">
                            <button className="yc-btn-cancel" onClick={() => setViewOrder(null)}>Закрыть</button>
                            {canEdit && (
                                <button
                                    className="yc-btn-save"
                                    onClick={() => {
                                        setViewOrder(null);
                                        openOrderModal(viewOrder);
                                    }}
                                >
                                    Изменить
                                </button>
                            )}
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default YurtCump;